class DateFormat {
  /**
   * Pass true as a second attribute if you want to return
   * the time together with the date
   *
   * @param {Date} dateToFormat
   * @param {Boolean} returnTime
   * @param {String} delimiter
   * @returns {Date} dd-mm-yyyy
   */
  formatDate(dateToFormat, returnTime = false, delimiter = "-") {
    let dateString = '';
    if (dateToFormat) {
      let date = new Date(dateToFormat.replace(/\s/g, "T"));
      let newDate = date.toLocaleString("en-GB", {
        timeZone: "Europe/Berlin",
      });

      dateString = String(newDate.replace(/\//g, delimiter));

      if (returnTime == false) {
        return dateString.split(",")[0];
      }
    }

    return dateString;
  }

  /**
   * Restore format to yyyy-mm-dd
   *
   * @param {Date} date
   * @param {String} delimiter in case the delimiter is not '-'
   * @returns
   */
  restoreFormat(date, delimiter = "-") {
    console.log(date);

    const dateToString = String(date);
    const splitDate = dateToString.split(delimiter);

    return splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
  }

  /**
   * Ramove date and format time
   *
   * @param {Date} time
   * @returns
   */
  formatTime(time) {
    let replaceTime = new Date(time.replace(/\s/g, "T"));

    let newTime = replaceTime.toLocaleString("en-GB", {
      timeZone: "Europe/Berlin",
    });
    let timeString = String(newTime);

    let formatedTime = timeString.split(",")[1];

    formatedTime = formatedTime.replace(/(.*)\D\d+/, '$1'); // remove seconds

    return formatedTime;
  }
}

export default DateFormat;
